export default "__VITE_ASSET__DRxfUE5K__"